/*
 *
 * Header actions
 *
 */

import { action } from 'typesafe-actions';

import ActionTypes from './constants';
import TabNames from './TabNames';

export const switchTabAction = (
  tab: TabNames,
  tutorial?: number,
  tutorialCallback?: any,
) =>
  action(ActionTypes.SWITCH_TAB_REQUEST, { tab, tutorial, tutorialCallback });

export const updateTabDisplayedAction = (tab: TabNames) =>
  action(ActionTypes.TAB_DISPLAYED_CHANGED, { tab });
